module.exports = __webpack_public_path__ + "static/media/team-01.fb9fe4a5.png";